export const PRINTERS = [
  {
    id: 'zebra-zd220',
    manufacturer: 'Zebra',
    model: 'ZD220 (203 dpi)',
    erpLanguage: 'ZPL',
    dpi: 203,
    maxWidthMm: 104,
    barcodes: ['EAN13', 'CODE128'],
    notes: 'ZPL II. A impressora precisa estar em ZPL.',
  },
  {
    id: 'zebra-zd220-epl',
    manufacturer: 'Zebra',
    model: 'ZD220 (203 dpi) — EPL',
    erpLanguage: 'EPL',
    dpi: 203,
    maxWidthMm: 104,
    barcodes: ['EAN13', 'CODE128'],
    notes: 'EPL2. Use só se a impressora estiver em modo EPL.',
  },
  {
    id: 'elgin-l42pro',
    manufacturer: 'Elgin',
    model: 'L42 Pro — PPLB',
    erpLanguage: 'PPLB',
    dpi: 203,
    maxWidthMm: 104,
    barcodes: ['EAN13', 'CODE128'],
    notes: 'PPLB (sintaxe EPL2). A emulação PPLB precisa estar ativa.',
  },
  {
    id: 'elgin-l42pro-zpl',
    manufacturer: 'Elgin',
    model: 'L42 Pro — ZPL',
    erpLanguage: 'ZPL',
    dpi: 203,
    maxWidthMm: 104,
    barcodes: ['EAN13', 'CODE128'],
    notes: 'ZPL com a impressora em emulação PPLZ.',
  },
  {
    id: 'argox',
    manufacturer: 'Argox',
    model: 'OS/CP — PPLB',
    erpLanguage: 'PPLB',
    dpi: 203,
    maxWidthMm: 104,
    barcodes: ['EAN13', 'CODE128'],
    notes: 'PPLB. A Argox precisa estar em PPLB, não em PPLA.',
  },
];

export const getPrinter = (id) => PRINTERS.find((p) => p.id === id) || PRINTERS[0];
